"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
// @file Validate Wall fields and attributes
/* eslint-disable camelcase, @typescript-eslint/camelcase */
var check_wall_address_valid_1 = __importDefault(require("./check_wall_address_valid"));
var errors_1 = require("./errors");
/**
 * Rules:
 * 1. Wall names must only consist of _, letters, and numbers.
 * 2. Wall names can only be a maximum of 50 characters
 *
 * @param wall A Wall instance.
 * @returns A Promise that resolves to a ValidatedErrorReason if the wall's field is invalid; null otherwise.
 */
function checkValidName(wall) {
  return __awaiter(this, void 0, void 0, function () {
    var name;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          name = wall.name;
          if (!name) return [3 /*break*/, 2];
          return [4 /*yield*/, (0, check_wall_address_valid_1.default)(name)];
        case 1:
          if (!_a.sent()) {
            throw new errors_1.FieldValidationError('name', 'Must be letters, numbers or underscores, with length of less than 50 characters.', 'Invalid name');
          }
          _a.label = 2;
        case 2:
          if (!name) {
            throw new errors_1.FieldValidationError('name', 'Must be present', 'Invalid name');
          }
          return [2 /*return*/, wall];
      }
    });
  });
}
/**
 * @ignore
 */
var ALLOWED_VIZES = ['stream', 'grid', 'matrix', 'shelf', 'chat', 'free', 'map', 'table', 'timeline', 'timeline_v2'];
/**
 * Checks to see if wall format is correct.
 * @param wall Wall instance.
 * @returns A Promise that resolves to a ValidatedErrorReason if the wall's field is invalid; null otherwise.
 */
function checkValidViz(wall) {
  return __awaiter(this, void 0, void 0, function () {
    var viz;
    return __generator(this, function (_a) {
      viz = wall.viz;
      if (!ALLOWED_VIZES.includes(viz)) {
        throw new errors_1.FieldValidationError('viz', "Must be one of ".concat(ALLOWED_VIZES.join(', ')), 'Invalid viz');
      }
      return [2 /*return*/, wall];
    });
  });
}
/**
 * @ignore
 */
var ALLOWED_NEW_WISH_LOC = ['top', 'bottom'];
/**
 * Checks to see if where we populate new fields is a string we recognize.
 * @param wall Wall instance.
 * @returns A Promise that resolves to a ValidatedErrorReason if the wall's field is invalid; null otherwise.
 */
function checkValidNewWishLoc(wall) {
  return __awaiter(this, void 0, void 0, function () {
    var new_wish_loc;
    return __generator(this, function (_a) {
      new_wish_loc = wall.new_wish_loc;
      if (!ALLOWED_NEW_WISH_LOC.includes(new_wish_loc)) {
        throw new errors_1.FieldValidationError('new_wish_loc', "Must be one of ".concat(ALLOWED_NEW_WISH_LOC.join(', ')), 'Invalid new_wish_loc');
      }
      return [2 /*return*/, wall];
    });
  });
}
/**
 * Checks to see if wall's background exists and is (nominally) correct.
 * @param wall Wall instance.
 * @returns A Promise that resolves to a ValidatedErrorReason if the wall's field is invalid; null otherwise.
 */
function checkValidBackground(wall) {
  return __awaiter(this, void 0, void 0, function () {
    var background, url;
    return __generator(this, function (_a) {
      background = wall.background;
      if (!background) {
        throw new errors_1.FieldValidationError('background', 'Must be present', 'Invalid background');
      }
      url = background.url;
      if (!url) {
        throw new errors_1.FieldValidationError('background', 'Must have URL', 'Invalid background URL');
      }
      return [2 /*return*/, wall];
    });
  });
}
/**
 * @ignore
 */
var ALLOWED_REACTION_TYPES = ['like', 'star', 'grade', 'vote'];
/**
 * Checks to see if wall's reaction data consists of data that's correct.
 * Rules:
 * 1. If is_reactable is true, then reaction_data must exist.
 * 2. If reaction_data exists, then reaction_data.type must be one of 'like', 'star', 'grade', 'vote'
 * 3. If reaction_data exists and type is grade, then reaction_data.max_value must be greater than 0 and less than or equal to 100.
 * 4. reaction_data.max_value if it exists must be a number.
 * @param wall Wall instance.
 * @returns A Promise that resolves to a ValidatedErrorReason if the wall's field is invalid; null otherwise.
 */
function checkValidReactionData(wall) {
  return __awaiter(this, void 0, void 0, function () {
    var is_reactable, reaction_data, max_value;
    return __generator(this, function (_a) {
      is_reactable = wall.is_reactable, reaction_data = wall.reaction_data;
      if (is_reactable === true) {
        if (!reaction_data) {
          throw new errors_1.FieldValidationError('reaction_data', 'Required if is_reactable is true', 'Missing reaction_data');
        }
        if (!reaction_data.type) {
          throw new errors_1.FieldValidationError('reaction_data', 'Requires a type', 'Missing reaction_data type');
        }
        if (!ALLOWED_REACTION_TYPES.includes(reaction_data.type)) {
          throw new errors_1.FieldValidationError('reaction_data', "Requires that type exist in allowed types: ".concat(ALLOWED_REACTION_TYPES.join(', ')), 'Invalid reaction_data type');
        }
        // validate grade max value
        if (reaction_data.type === 'grade') {
          max_value = reaction_data.max_value;
          if (!max_value) {
            throw new errors_1.FieldValidationError('reaction_data', 'Must have max_value for type grade', 'Missing max_value');
          }
          if (typeof max_value !== 'number') {
            throw new errors_1.FieldValidationError('reaction_data', 'max_value must be a number', 'max_value type is invalid');
          }
          if (max_value < 1 || max_value > 100) {
            throw new errors_1.FieldValidationError('reaction_data', 'max_value must be between 1 and 100 inclusive', 'Invalid max_value');
          }
        } else if (reaction_data.max_value) {
          throw new errors_1.FieldValidationError('reaction_data', 'Only type grade can have a max_value', 'Unwanted max_value');
        }
      }
      return [2 /*return*/, wall];
    });
  });
}
/**
 * Checks to see if wall has a valid.
 * Rules:
 * 1. domain_name cannot end with padlet.com
 * 2. domain_name cannot end with padlet.org
 * @param wall Wall instance.
 * @returns A Promise that resolves to a ValidatedErrorReason if the wall's field is invalid; null otherwise.
 */
function checkValidDomainName(wall) {
  return __awaiter(this, void 0, void 0, function () {
    var domain_name;
    return __generator(this, function (_a) {
      domain_name = wall.domain_name;
      if (domain_name) {
        if (domain_name.match(/\.padlet\.com$/)) {
          throw new errors_1.FieldValidationError('domain_name', 'Cannot use padlet.com domain', 'Invalid domain_name');
        }
        if (domain_name.match(/\.padlet\.org$/)) {
          throw new errors_1.FieldValidationError('domain_name', 'Cannot use padlet.org domain', 'Invalid domain_name');
        }
      }
      return [2 /*return*/, wall];
    });
  });
}
/**
 * Throws a validation error when an invalid Wall is passed in.
 * @param wall A Wall instance.
 * @returns A Promise that resolves to the same Wall if it is valid; rejected with a ValidationError otherwise.
 */
function validateWall(wall) {
  return __awaiter(this, void 0, void 0, function () {
    var allFns, errorReasons;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          allFns = [checkValidViz, checkValidName, checkValidDomainName, checkValidNewWishLoc, checkValidBackground, checkValidReactionData];
          errorReasons = [];
          return [4 /*yield*/, Promise.all(allFns.map(function (fn) {
            return fn(wall).catch(function (e) {
              return errorReasons.push(e.reason);
            });
          }))];
        case 1:
          _a.sent();
          if (errorReasons.length > 0) {
            throw new errors_1.ValidationError('Invalid wall', errorReasons);
          }
          return [2 /*return*/, wall];
      }
    });
  });
}
exports.default = validateWall;